(function($){
    $('.show-reset-pass-form').on('click', function(e){
        e.preventDefault();
        $(this).closest('.card').fadeOut(250);
        $('#reset-pass-form').fadeIn(250);
    })
})(jQuery);